exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".containerSection {\n  padding-top: 13px;\n  text-align: center;\n  padding-bottom: 13px; }\n\n.company {\n  font-size: 26px;\n  font-weight: 400;\n  opacity: 0.7;\n  color: #666565; }\n\n.designBySection {\n  font-size: 19.5px;\n  opacity: 0.5;\n  color: #757373;\n  text-align: center;\n  padding-top: 26px;\n  font-weight: 500; }\n\n.designByCo {\n  color: #1f1e1e; }\n\n.iconSection {\n  padding-right: 39px; }\n\n.iconStyle {\n  color: #a49f9f;\n  font-weight: 700;\n  font-size: 29.25px;\n  padding-left: 9.75px;\n  padding-right: 13px; }\n", ""]);

// exports
